const rankings = [
  {
    rank: 1,
    title: '某顶流艺人深夜密会神秘女子，酒店同框照曝光',
    heat: '236.8万',
    trend: 'up',
    change: '+128%',
    tag: '娱乐圈',
  },
  {
    rank: 2,
    title: '年度最炸裂黑料：某剧组内部聊天记录被曝光',
    heat: '198.5万',
    trend: 'up',
    change: '+95%',
    tag: '影视圈',
  },
  {
    rank: 3,
    title: '千万粉丝网红涉嫌虚假宣传遭集体维权事件',
    heat: '165.3万',
    trend: 'up',
    change: '+72%',
    tag: '网红圈',
  },
  {
    rank: 4,
    title: '热门综艺录制现场突发意外，节目组紧急叫停',
    heat: '142.7万',
    trend: 'new',
    change: 'NEW',
    tag: '综艺',
  },
  {
    rank: 5,
    title: '知名歌手新歌被指抄袭海外作品，制作人回应',
    heat: '118.9万',
    trend: 'down',
    change: '-15%',
    tag: '音乐圈',
  },
];

const rankColors: Record<number, string> = {
  1: 'bg-accent-500 text-background-50',
  2: 'bg-accent-400 text-background-50',
  3: 'bg-secondary-500 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            黑料热度榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            实时热度排行，最热门的内容都在这里
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/50 rounded-xl overflow-hidden">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-3 md:gap-4 p-4 md:p-5 ${
                i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-primary-50/30 transition-colors cursor-pointer`}
            >
              <div
                className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center text-sm font-heading flex-shrink-0 ${
                  rankColors[item.rank] || 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-1.5 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base text-foreground-800 font-medium line-clamp-1">
                  {item.title}
                </h3>
              </div>

              <div className="text-right flex-shrink-0">
                <div className="flex items-center gap-1 text-primary-500 text-sm md:text-base font-heading">
                  <i className="ri-fire-line text-xs"></i>
                  {item.heat}
                </div>
                <span
                  className={`text-xs ${
                    item.trend === 'up'
                      ? 'text-accent-500'
                      : item.trend === 'new'
                        ? 'text-primary-500'
                        : 'text-foreground-400'
                  }`}
                >
                  {item.trend === 'up' && <i className="ri-arrow-up-line mr-0.5"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line mr-0.5"></i>}
                  {item.change}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#cards"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
          >
            查看完整榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}